import './WhyParticipate.scss';

import Cards from '@components/Cards/Cards';
import { BRIDGE_BIO_CAMPAIGN_CODE } from '@constants/bridgeBio';

import { CasrcadePathways } from './CasrcadePathways';

interface WhyParticipateProps {
  campaignCode?: string;
  onInviteFamily: () => void;
  onOrderTesting: () => void;
  onReferPatient: () => void;
}

const SHOW_CASRCADE_PATHWAYS: boolean = false;

export const WhyParticipate = (props: WhyParticipateProps) => {
  const { campaignCode, onInviteFamily, onOrderTesting, onReferPatient } = props;
  const isBridgeBio = campaignCode === BRIDGE_BIO_CAMPAIGN_CODE;

  if (isBridgeBio) {
    if (SHOW_CASRCADE_PATHWAYS) {
      return (
        <CasrcadePathways
          onInviteFamily={onInviteFamily}
          onOrderTesting={onOrderTesting}
          onReferPatient={onReferPatient}
        />
      );
    }
    return null;
  }

  return (
    <section className='why-participate'>
      <Cards background='white' sectionHeader={<h2>Why Participate in the MyOme Program?</h2>}>
        <ul className='features'>
          <li className='feature'>
            <h3 className='feature__title'>Comprehensive Whole-Genome Insights</h3>
            <p className='feature__body'>
              Understand personal health risks to make informed prevention and treatment decisions.
            </p>
          </li>

          <li className='feature'>
            <h3 className='feature__title'>Clinically Validated and Actionable</h3>
            <p className='feature__body'>
              Trusted by experts. All results have clear explanations to inform next steps.
            </p>
          </li>

          <li className='feature'>
            <h3 className='feature__title'>Private and Secure</h3>
            <p className='feature__body'>Your data is protected and confidential: CLIA/CAP and HIPAA-compliant.</p>
          </li>

          <li className='feature'>
            <h3 className='feature__title'>Easy to Get Started</h3>
            <p className='feature__body'>
              No complex steps. MyOme handles logistics, and genetic counselors are here to support you.
            </p>
          </li>
        </ul>
      </Cards>
    </section>
  );
};
